import { render } from "./baobeiOrderAuditManage.vue?vue&type=template&id=15936258"
import script from "./baobeiOrderAuditManage.vue?vue&type=script&lang=js"
export * from "./baobeiOrderAuditManage.vue?vue&type=script&lang=js"

import "./baobeiOrderAuditManage.vue?vue&type=style&index=0&id=15936258&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__